import React, { Component } from 'react';
import PropTypes from 'prop-types';

import darklogo from 'assets/images/logo/logo_dark.png';
import logo from 'assets/images/logo/logo.png';
import { Nav } from 'C4';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: true,
    };
  }

  componentWillMount() {
    setTimeout(() => {
      this.changeCopy();
    }, 4000);
  }

  changeCopy() {
    if (this.state.header) {
      this.setState({ header: false });
    } else {
      this.setState({ header: true });
    }
    setTimeout(() => {
      this.changeCopy();
    }, 5000);
  }

  render() {
    const { pathname } = this.props;
    let path = '/main';
    if (pathname && pathname.match(/\/(.*?)\/(.*?)\//g)) {
      const [returnPath] = pathname.match(/\/(.*?)\/(.*?)\//g);
      path = returnPath.substring(0, returnPath.length - 1);
    }

    return (
      <span>
        <div className="header">
          {pathname.length > 7 &&
            <React.Fragment>
              <Link
                className="backLink"
                to={path}
              >
                <FontAwesomeIcon icon={['fas', 'chevron-left']} /> Back
              </Link>
              <img src={`/${logo}`} className="logo" alt="logo" id="logoHeader" />
            </React.Fragment>
          }
          {pathname.length <= 7 &&
            <span className="homeHeader">
              <div className="topper" />
              <h3 className={this.state.header ? 'hidden' : ''}>Enjoy the Show and THANK YOU to our Sponsors<br />July 23, 2020 11:30am  4:00pm</h3>
              <span className={this.state.header ? '' : 'hidden'}><img src={`/${darklogo}`} alt="logo" id="logoHeader" /></span>
              <div className="bottomer" />
            </span>
          }
          <Nav pathname={pathname} />
        </div>
      </span>
    );
  }
}

Header.propTypes = {
  pathname: PropTypes.shape().isRequired,
};
